// AVIF-first picture wrapper. `src` must be a local .webp path; the matching
// .avif file must exist alongside it. `display: contents` keeps layout intact.
export const Pic = ({ src, srcSet, sizes, ...imgProps }) => (
  <picture className="contents">
    <source
      type="image/avif"
      srcSet={srcSet ? srcSet.replaceAll(".webp", ".avif") : src.replace(/\.webp$/, ".avif")}
      sizes={sizes}
    />
    <img src={src} srcSet={srcSet} sizes={sizes} {...imgProps} />
  </picture>
);
